import script from "./submitOrder.vue?vue&type=script&setup=true&lang=ts"
export * from "./submitOrder.vue?vue&type=script&setup=true&lang=ts"

import "./submitOrder.vue?vue&type=style&index=0&id=37f9f4e2&scoped=true&lang=less"

import exportComponent from "/data/liulv-h5/International-card-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37f9f4e2"]])

export default __exports__